import TutorialPage from "./tutorial-page"

export const SchoolStudentTutorialPage = () => {


    return (
        <TutorialPage variant='school-student'/>
    )

}